module.exports = __webpack_public_path__ + "static/media/coins.17d0c4eb.png";